module.exports = __webpack_public_path__ + "img/marker-icon-pmp-2x.74b434a4.png";